import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss'],
})
export class RegisterSuccessComponent implements OnInit {
  requestId!: string;
  user!: string;
  operation!: string;
  accessToken!: string;
  trackId!: string;
  constructor(private cidaas: CidaasService, private route: ActivatedRoute, public commonFunc: CommonFunctionsService) {}

  ngOnInit(): void {
    this.operation = 'OPERATION.REGISTERED';
    this.route.queryParams.subscribe((params) => {
      this.user = params.name || null;
      this.requestId = params.requestId || null;
      this.trackId = params.trackId || null;
    });
  }

  // handling autologin after register
  redirectAutoLogin = () => {
    const options = {
      trackId: this.trackId,
    };
    this.cidaas._loginAfterRegister(options);
  };
}
